

export function getJsonData(id) {
    const el = document.getElementById(id);
    if (el) {
        return JSON.parse(el.textContent);
    }

    return null;
}

export function getAnimScript(script) {
    if (!script) {
        return null;
    }
    if (typeof script === 'object') {
        return script.animscript || script;
    }
    if (typeof script === 'string') {
        if (typeof window[script] !== 'undefined') {
            return window[script].animscript || window[script];
        }
    }
    return null;
}

// @ts-ignore
window.getAnimScript = getAnimScript;